module.exports = __webpack_public_path__ + "abb9f6121f63eb32aaba5f3e76fd4c4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/bg_1.png
// module id = 242
// module chunks = 1